import { SpecialistsList } from "@/components";
import { SpecialistsListHero } from "@/components";
import SeoHelmet from "@/hooks/helmet";

function SpecialistsListPage() {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-4 pt-7 lg:gap-7">
      <SeoHelmet
        titleKey="metatags.specialistsListPage.appTitle"
        descriptionKey="metatags.specialistsListPage.description"
        keywordsKey="metatags.specialistsListPage.keywords"
        authorKey="metatags.specialistsListPage.author"
      />
      <SpecialistsListHero />
      <SpecialistsList />
    </div>
  );
}

export { SpecialistsListPage };
